import { render, staticRenderFns } from "./iconMoney.vue?vue&type=template&id=32c45972&scoped=true"
import script from "./iconMoney.vue?vue&type=script&lang=js"
export * from "./iconMoney.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c45972",
  null
  
)

export default component.exports